import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import OrgFilterField from './OrgFilterField';
import {
  resetOrgClinicalTrialFilters,
  setOrgClinicalTrialFilterGroups,
} from 'actions/organisation';
import { Button } from 'components/common';
import { getOrganisationClinicalTrialFilter } from 'selectors/organisation';

const Content = styled.div`
  padding: 0px 0px 10px;
  > * {
    margin-bottom: 10px;
    :last-child {
      margin-bottom: 5px;
    }
  }
`;

export const Actions = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
`;

export const OrganisationClinicalTrialFilters = ({
  organisationId,
  onFilterUpdate,
  loading,
}) => {
  const dispatch = useDispatch();

  const handleSearch = () => {
    onFilterUpdate();
  };

  const handleReset = () => {
    dispatch(resetOrgClinicalTrialFilters(organisationId));
  };
  return (
    <>
      <Content>
        <OrgFilterField
          filterType='checkbox'
          checkValue={true}
          filterId='leadSponsor'
          organisationId={organisationId}
          setFilterGroup={setOrgClinicalTrialFilterGroups}
          getFilter={getOrganisationClinicalTrialFilter}
          disabled={loading}
          labelText='Lead Sponsor'
        />
        <OrgFilterField
          filterType='checkbox'
          checkValue={true}
          filterId='collaboratorSponsor'
          organisationId={organisationId}
          setFilterGroup={setOrgClinicalTrialFilterGroups}
          getFilter={getOrganisationClinicalTrialFilter}
          disabled={loading}
          labelText='Collaborator'
        />
      </Content>
      <Actions>
        <Button
          data-testid='filter-reset'
          onClick={handleReset}
          disabled={loading}
        >
          Reset
        </Button>
        <Button
          onClick={handleSearch}
          type='primary'
          style={{ marginLeft: '10px' }}
          data-testid='filter-update'
          disabled={loading}
        >
          Update
        </Button>
      </Actions>
    </>
  );
};

OrganisationClinicalTrialFilters.propTypes = {
  organisationId: PropTypes.number.isRequired,
  onFilterUpdate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
